import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { DragulaModule } from 'ng2-dragula';
import { DataTableModule } from 'angular2-datatable';
import { AlertModule } from 'ng2-bootstrap';
import { JasperoConfirmationsModule } from '@jaspero/ng2-confirmations';

import { AuthGuard } from '../../common/auth.guard';
import { CanDeactivateGuard } from '../../common/can-deactivate-guard.service';
import { AuthenticationService } from './../utils/authentication.service';

import { DataService } from './api.service';
import { BaseComponent } from './base.component';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from './../utils/token.interceptor';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    HttpModule,
    RouterModule,
    SimpleNotificationsModule.forRoot(),
    DragulaModule,
    DataTableModule,
    AlertModule,
    HttpClientModule
  ],
  declarations: [
    BaseComponent
  ],
  exports: [
    CommonModule,
    FormsModule,
    HttpModule,
    RouterModule,
    SimpleNotificationsModule,
    DragulaModule,
    DataTableModule,
    AlertModule,
    JasperoConfirmationsModule
  ],
  providers: [
    AuthenticationService,
    AuthGuard,
    CanDeactivateGuard,
    DataService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    }
  ],
})
export class SharedModule {}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts